import { MobileIcon } from '@/components/icons/MobileIcon'
import { IdCardIcon } from '@/components/icons/IdCardIcon'
import { Text } from '@/components'
import { useTranslation } from 'react-i18next'
import { PenIcon } from './icons/PenIcon'

interface RequirementsSectionProps {
  showCencertCode?: boolean
}

export function RequirementsSection({
  showCencertCode = false,
}: RequirementsSectionProps) {
  const { t } = useTranslation()

  return (
    <section className='mb-2 sm:mb-3'>
      <Text
        typographyVariant='heading-4'
        color='navy'
        className='font-semibold mb-5 sm:mb-4'
      >
        {t('requirementsSection.title')}
      </Text>

      <div className='space-y-2.5'>
        <div className='flex items-center gap-3'>
          <MobileIcon className='w-8 h-8 text-cencert-blue' />
          <Text as='span' variant='base' color='navy' className='font-medium'>
            {t('requirementsSection.mobileApp')}{' '}
            <strong>{t('requirementsSection.mobileAppName')}</strong>
          </Text>
        </div>

        <div className='flex items-center gap-3'>
          <IdCardIcon className='w-8 h-8 text-cencert-blue' />
          <Text as='span' variant='base' color='navy' className='font-medium'>
            {t('requirementsSection.idCard')}
          </Text>
        </div>

        {showCencertCode && (
          <div className='flex items-center gap-3'>
            <PenIcon className='w-8 h-8 fill-cencert-blue' />
            <Text as='span' variant='base' color='navy' className='font-medium'>
              {t('requirementsSection.cencertCode')}
            </Text>
          </div>
        )}
      </div>
    </section>
  )
}
